import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "assets-grid-title" }
const _hoisted_2 = { class: "assets-grid-title__text" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { class: "asset-group-location-form" }
const _hoisted_6 = {
  key: 0,
  class: "alert alert-danger d-flex align-items-center gap-2 mb-4"
}
const _hoisted_7 = { class: "form-section" }
const _hoisted_8 = { class: "form-section-title" }
const _hoisted_9 = { class: "alert alert-info d-flex align-items-start gap-2 mb-3" }
const _hoisted_10 = { class: "scheme-upload-section" }
const _hoisted_11 = { class: "position-sticky top-0 z-3 bg-white py-2 border-bottom mb-3" }
const _hoisted_12 = { class: "d-flex flex-wrap gap-2 align-items-center justify-content-between" }
const _hoisted_13 = { class: "text-muted small" }
const _hoisted_14 = { class: "card-body" }
const _hoisted_15 = { class: "d-flex flex-wrap justify-content-between align-items-center gap-2 mb-2" }
const _hoisted_16 = { class: "fw-bold" }
const _hoisted_17 = {
  key: 0,
  class: "text-muted"
}
const _hoisted_18 = { class: "d-flex flex-wrap gap-2" }
const _hoisted_19 = ["disabled", "onClick"]
const _hoisted_20 = ["onClick"]
const _hoisted_21 = { class: "mb-3" }
const _hoisted_22 = { class: "form-label" }
const _hoisted_23 = { key: 0 }
const _hoisted_24 = ["id", "disabled", "onChange"]
const _hoisted_25 = {
  key: 0,
  class: "invalid-feedback d-block"
}
const _hoisted_26 = {
  key: 1,
  class: "image-preview mt-2"
}
const _hoisted_27 = ["src"]
const _hoisted_28 = ["disabled", "onClick"]
const _hoisted_29 = {
  key: 2,
  class: "text-muted"
}
const _hoisted_30 = { class: "mb-3" }
const _hoisted_31 = ["onUpdate:modelValue", "disabled"]
const _hoisted_32 = { class: "form-section" }
const _hoisted_33 = { class: "form-section-title" }
const _hoisted_34 = { class: "card-body" }
const _hoisted_35 = { class: "d-flex justify-content-between align-items-center mb-2" }
const _hoisted_36 = { class: "fw-bold" }
const _hoisted_37 = {
  key: 0,
  class: "text-muted"
}
const _hoisted_38 = ["onClick"]
const _hoisted_39 = { class: "mb-3" }
const _hoisted_40 = { class: "form-label" }
const _hoisted_41 = { key: 0 }
const _hoisted_42 = ["id", "disabled", "onChange"]
const _hoisted_43 = { class: "text-muted" }
const _hoisted_44 = {
  key: 0,
  class: "invalid-feedback d-block"
}
const _hoisted_45 = {
  key: 1,
  class: "image-preview mt-2"
}
const _hoisted_46 = ["src"]
const _hoisted_47 = ["disabled", "onClick"]
const _hoisted_48 = {
  key: 2,
  class: "text-muted"
}
const _hoisted_49 = { class: "mb-3" }
const _hoisted_50 = ["onUpdate:modelValue", "placeholder", "disabled"]
const _hoisted_51 = { class: "mb-3" }
const _hoisted_52 = { class: "form-label" }
const _hoisted_53 = ["onUpdate:modelValue", "placeholder", "disabled"]
const _hoisted_54 = { class: "text-muted small" }
const _hoisted_55 = { class: "d-flex justify-content-between w-100" }
const _hoisted_56 = ["disabled"]
const _hoisted_57 = {
  key: 0,
  class: "spinner-border spinner-border-sm me-2"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_base_modal = _resolveComponent("base-modal")!

  return (_openBlock(), _createBlock(_component_base_modal, {
    ref: "modalRef",
    nested: false,
    size: "xl"
  }, {
    header: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _cache[4] || (_cache[4] = _createElementVNode("div", { class: "assets-grid-title__icon" }, [
          _createElementVNode("i", { class: "bi bi-hdd-rack-fill" })
        ], -1)),
        _createElementVNode("div", _hoisted_2, [
          (_ctx.isReadOnly)
            ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.$t('components.assetGroupsWithLocation.modal.viewTitle')) + ": " + _toDisplayString(_ctx.groupName), 1))
            : (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_ctx.groupName ? `${_ctx.$t('components.assetGroupsWithLocation.modal.editTitle')}: ${_ctx.groupName}` : _ctx.$t('components.assetGroupsWithLocation.modal.viewTitle')), 1))
        ])
      ])
    ]),
    body: _withCtx(() => [
      _createElementVNode("div", _hoisted_5, [
        (_ctx.errorMessage)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _cache[5] || (_cache[5] = _createElementVNode("i", { class: "bi bi-exclamation-triangle-fill" }, null, -1)),
              _createElementVNode("span", null, _toDisplayString(_ctx.errorMessage), 1)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("form", {
          onSubmit: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleSubmit && _ctx.handleSubmit(...args)), ["prevent"]))
        }, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("h5", _hoisted_8, [
              _cache[6] || (_cache[6] = _createElementVNode("i", { class: "bi bi-image me-2" }, null, -1)),
              _createTextVNode(" " + _toDisplayString(_ctx.$t('components.assetGroupsWithLocation.modal.locationImage')), 1)
            ]),
            _createElementVNode("div", _hoisted_9, [
              _cache[7] || (_cache[7] = _createElementVNode("i", { class: "bi bi-info-circle-fill mt-1" }, null, -1)),
              _createElementVNode("small", null, _toDisplayString(_ctx.$t('components.assetGroupsWithLocation.modal.hints.locationImage')), 1)
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.$t('components.assetGroupsWithLocation.modal.hints.locationImage')), 1),
                  (!_ctx.isReadOnly)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        type: "button",
                        class: "btn assets-toolbar-btn",
                        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.addLocationImageEntry && _ctx.addLocationImageEntry(...args)))
                      }, [...(_cache[8] || (_cache[8] = [
                        _createElementVNode("i", { class: "bi bi-plus-circle me-1" }, null, -1),
                        _createTextVNode(" Dodaj zdjęcie ", -1)
                      ]))]))
                    : _createCommentVNode("", true)
                ])
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.locationImages, (image, imgIdx) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: image.uid,
                  class: _normalizeClass(["card mb-3", { 'border-danger': image.remove }])
                }, [
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("div", _hoisted_15, [
                      _createElementVNode("div", _hoisted_16, [
                        _createTextVNode(_toDisplayString(_ctx.$t('components.assetGroupsWithLocation.modal.locationImage')) + " #" + _toDisplayString(imgIdx + 1) + " ", 1),
                        (image.existing)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_17, "(" + _toDisplayString(_ctx.$t('common.existing')) + ")", 1))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_18, [
                        (!_ctx.isReadOnly)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 0,
                              type: "button",
                              class: "btn assets-toolbar-btn btn-sm",
                              disabled: image.remove,
                              onClick: ($event: any) => (_ctx.addSchemeEntry(imgIdx))
                            }, [
                              _cache[9] || (_cache[9] = _createElementVNode("i", { class: "bi bi-plus-circle me-1" }, null, -1)),
                              _createTextVNode(" " + _toDisplayString(_ctx.$t('components.assetGroupsWithLocation.modal.addScheme')), 1)
                            ], 8, _hoisted_19))
                          : _createCommentVNode("", true),
                        (!_ctx.isReadOnly)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 1,
                              type: "button",
                              class: _normalizeClass(["btn btn-sm", image.remove ? 'btn-outline-secondary' : 'btn-outline-danger']),
                              onClick: ($event: any) => (_ctx.toggleRemoveLocationImage(imgIdx))
                            }, [
                              _createElementVNode("i", {
                                class: _normalizeClass([image.remove ? 'bi bi-arrow-counterclockwise' : 'bi bi-trash', "me-1"])
                              }, null, 2),
                              _createTextVNode(" " + _toDisplayString(image.remove ? _ctx.$t('common.restore') : _ctx.$t('common.remove')), 1)
                            ], 10, _hoisted_20))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_21, [
                      _createElementVNode("label", _hoisted_22, [
                        _cache[10] || (_cache[10] = _createElementVNode("i", { class: "bi bi-file-image me-2" }, null, -1)),
                        _createTextVNode(" " + _toDisplayString(_ctx.$t('components.assetGroupsWithLocation.modal.fields.locationImage')), 1)
                      ]),
                      (!_ctx.isReadOnly)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                            _createElementVNode("input", {
                              id: `locationImage-${image.uid}`,
                              type: "file",
                              class: _normalizeClass(["form-control", { 'is-invalid': image.error }]),
                              accept: "image/jpeg,image/png,image/webp,image/gif",
                              disabled: image.remove,
                              onChange: ($event: any) => (_ctx.handleLocationImageChange($event, imgIdx))
                            }, null, 42, _hoisted_24),
                            (image.error)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_25, _toDisplayString(image.error), 1))
                              : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true),
                      (image.preview)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                            _createElementVNode("img", {
                              src: image.preview,
                              alt: "Location preview"
                            }, null, 8, _hoisted_27),
                            (!_ctx.isReadOnly && image.file)
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 0,
                                  type: "button",
                                  class: "btn-remove-preview",
                                  disabled: image.remove,
                                  onClick: ($event: any) => (_ctx.clearLocationImageFile(imgIdx))
                                }, [...(_cache[11] || (_cache[11] = [
                                  _createElementVNode("i", { class: "bi bi-x-circle-fill" }, null, -1)
                                ]))], 8, _hoisted_28))
                              : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.isReadOnly && !image.preview)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_29, _toDisplayString(_ctx.$t('components.assetGroupsWithLocation.modal.noImage')), 1))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_30, [
                      _cache[12] || (_cache[12] = _createElementVNode("label", { class: "form-label" }, " Nazwa zdjęcia ", -1)),
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": ($event: any) => ((image.name) = $event),
                        type: "text",
                        class: "form-control",
                        maxlength: "255",
                        disabled: _ctx.isReadOnly || image.remove
                      }, null, 8, _hoisted_31), [
                        [_vModelText, image.name]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_32, [
                      _createElementVNode("h6", _hoisted_33, [
                        _cache[13] || (_cache[13] = _createElementVNode("i", { class: "bi bi-diagram-3 me-2" }, null, -1)),
                        _createTextVNode(" " + _toDisplayString(_ctx.$t('components.assetGroupsWithLocation.modal.schemes')), 1)
                      ]),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(image.schemes, (scheme, idx) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: scheme.uid,
                          class: _normalizeClass(["card mb-3", { 'border-danger': scheme.remove }])
                        }, [
                          _createElementVNode("div", _hoisted_34, [
                            _createElementVNode("div", _hoisted_35, [
                              _createElementVNode("div", _hoisted_36, [
                                _createTextVNode(_toDisplayString(_ctx.$t('components.assetGroupsWithLocation.modal.fields.scheme')) + " #" + _toDisplayString(idx + 1) + " ", 1),
                                (scheme.existing)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_37, "(" + _toDisplayString(_ctx.$t('common.existing')) + ")", 1))
                                  : _createCommentVNode("", true)
                              ]),
                              (!_ctx.isReadOnly)
                                ? (_openBlock(), _createElementBlock("button", {
                                    key: 0,
                                    type: "button",
                                    class: _normalizeClass(["btn btn-sm", scheme.remove ? 'btn-outline-secondary' : 'btn-outline-danger']),
                                    onClick: ($event: any) => (_ctx.toggleRemoveScheme(imgIdx, idx))
                                  }, [
                                    _createElementVNode("i", {
                                      class: _normalizeClass([scheme.remove ? 'bi bi-arrow-counterclockwise' : 'bi bi-trash', "me-1"])
                                    }, null, 2),
                                    _createTextVNode(" " + _toDisplayString(scheme.remove ? _ctx.$t('common.restore') : _ctx.$t('common.remove')), 1)
                                  ], 10, _hoisted_38))
                                : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("div", _hoisted_39, [
                              _createElementVNode("label", _hoisted_40, [
                                _cache[14] || (_cache[14] = _createElementVNode("i", { class: "bi bi-file-image me-2" }, null, -1)),
                                _createTextVNode(" " + _toDisplayString(_ctx.$t('components.assetGroupsWithLocation.modal.fields.schemeFile')), 1)
                              ]),
                              (!_ctx.isReadOnly)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                                    _createElementVNode("input", {
                                      id: `schemeFile-${scheme.uid}`,
                                      type: "file",
                                      class: _normalizeClass(["form-control", { 'is-invalid': scheme.error }]),
                                      accept: "image/jpeg,image/png,image/webp,image/gif",
                                      disabled: scheme.remove,
                                      onChange: ($event: any) => (_ctx.handleSchemeFileChange($event, imgIdx, idx))
                                    }, null, 42, _hoisted_42),
                                    _createElementVNode("small", _hoisted_43, _toDisplayString(_ctx.$t('components.assetGroupsWithLocation.modal.hints.schemeFile')), 1),
                                    (scheme.error)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_44, _toDisplayString(scheme.error), 1))
                                      : _createCommentVNode("", true)
                                  ]))
                                : _createCommentVNode("", true),
                              (scheme.preview)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                                    _createElementVNode("img", {
                                      src: scheme.preview,
                                      alt: "Scheme preview"
                                    }, null, 8, _hoisted_46),
                                    (!_ctx.isReadOnly && scheme.file)
                                      ? (_openBlock(), _createElementBlock("button", {
                                          key: 0,
                                          type: "button",
                                          class: "btn-remove-preview",
                                          disabled: scheme.remove,
                                          onClick: ($event: any) => (_ctx.clearSchemeFile(imgIdx, idx))
                                        }, [...(_cache[15] || (_cache[15] = [
                                          _createElementVNode("i", { class: "bi bi-x-circle-fill" }, null, -1)
                                        ]))], 8, _hoisted_47))
                                      : _createCommentVNode("", true)
                                  ]))
                                : _createCommentVNode("", true),
                              (_ctx.isReadOnly && !scheme.preview)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_48, _toDisplayString(_ctx.$t('components.assetGroupsWithLocation.modal.noSchemeImage')), 1))
                                : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("div", _hoisted_49, [
                              _createElementVNode("label", {
                                class: _normalizeClass(["form-label", { required: scheme.file }])
                              }, _toDisplayString(_ctx.$t('components.assetGroupsWithLocation.modal.fields.schemeName')), 3),
                              _withDirectives(_createElementVNode("input", {
                                "onUpdate:modelValue": ($event: any) => ((scheme.name) = $event),
                                type: "text",
                                class: _normalizeClass(["form-control", { 'is-invalid': scheme.error && !scheme.name }]),
                                placeholder: _ctx.$t('components.assetGroupsWithLocation.modal.placeholders.schemeName'),
                                maxlength: "255",
                                disabled: _ctx.isReadOnly || scheme.remove
                              }, null, 10, _hoisted_50), [
                                [_vModelText, scheme.name]
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_51, [
                              _createElementVNode("label", _hoisted_52, _toDisplayString(_ctx.$t('components.assetGroupsWithLocation.modal.fields.schemeDescription')), 1),
                              _withDirectives(_createElementVNode("textarea", {
                                "onUpdate:modelValue": ($event: any) => ((scheme.description) = $event),
                                class: "form-control",
                                rows: "2",
                                placeholder: _ctx.$t('components.assetGroupsWithLocation.modal.placeholders.schemeDescription'),
                                disabled: _ctx.isReadOnly || scheme.remove
                              }, null, 8, _hoisted_53), [
                                [_vModelText, scheme.description]
                              ])
                            ])
                          ])
                        ], 2))
                      }), 128)),
                      _createElementVNode("div", _hoisted_54, _toDisplayString(_ctx.$t('components.assetGroupsWithLocation.modal.hints.schemeFile')), 1)
                    ])
                  ])
                ], 2))
              }), 128))
            ])
          ])
        ], 32)
      ])
    ]),
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_55, [
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-secondary",
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
        }, _toDisplayString(_ctx.$t('components.assetGroupsWithLocation.modal.close')), 1),
        (!_ctx.isReadOnly)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              type: "button",
              class: "btn btn-primary",
              disabled: _ctx.loading,
              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.handleSubmit && _ctx.handleSubmit(...args)))
            }, [
              (_ctx.loading)
                ? (_openBlock(), _createElementBlock("span", _hoisted_57))
                : _createCommentVNode("", true),
              _createTextVNode(" " + _toDisplayString(_ctx.$t('components.assetGroupsWithLocation.modal.save')), 1)
            ], 8, _hoisted_56))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 512))
}